import {consola as l} from "consola/basic";
import fcId from "./../fcId"

export default function (analyticsId) {

    (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date();
        a = s.createElement(o),
            m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

    ga('set', 'anonymizeIp', true);
    ga('create', analyticsId, 'auto');
    ga('create', 'UA-2107172-7', 'auto', 'reportglobale');
    ga('set', 'dimension68', fcId.get());
    ga('send', 'pageview');
    ga('reportglobale.send', 'pageview');
    l.info('Load google analytics:', analyticsId)

}